export const PORTAL_ID = '39988659';
export const RESOURCE_TYPE = 'RESOURCE';
export const regexForNumber = /\b\d+\.\w+|\b\d+\b/;
export const sdgRatingsArray = ['+5', '+4', '+3', '+2', '+1'];
export const ghgRatingsArray = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'C', 'D'];
